import { parseAkamaiHeader } from './parseAkamaiHeader.js';

/* eslint-disable no-console */
function handleAkamaiEdgescape({
  req
}) {
  if (req) {
    const edgescapeString = req.header('x-akamai-edgescape');
    if (edgescapeString) {
      if (!req.akamai) {
        req.akamai = {};
      }
      req.akamai.edgescape = parseAkamaiHeader(edgescapeString, {
        delimiter: ','
      });

      // If there are multiple zipcodes returned in the zip string then parse them to an array
      if (req.akamai.edgescape.zip) {
        const zips = req.akamai.edgescape.zip.split('+');
        if (zips.length > 1) {
          req.akamai.edgescape.zip = zips;
        }
      }
    }
  }
}
function expressAkamaiEdgescapeMiddleware(req, res, next) {
  handleAkamaiEdgescape({
    req});
  next();
}
function withCtxAkamaiEdgescape() {
  return ctx => {
    if (ctx.req) {
      handleAkamaiEdgescape(ctx);
    }
  };
}

export { expressAkamaiEdgescapeMiddleware, handleAkamaiEdgescape, withCtxAkamaiEdgescape };
